// import { APP_CONFIG_API_PREFIX } from "../../../../common/configs/configs"

import ApiUtils from "../ApiUtils"
import { APP_CONFIG_KEYS_ENUM, IConfigStoreService } from "./IConfgiStoreService"

const APP_CONFIG_API_PREFIX = "/app-config-cache"

const getAppConfigWithKeyUrl = (key: APP_CONFIG_KEYS_ENUM) => APP_CONFIG_API_PREFIX + `/get-config?configKey=${key}`

class ConfigStoreServiceApis implements IConfigStoreService {
	getConfig = (key: APP_CONFIG_KEYS_ENUM) => {
		const url = getAppConfigWithKeyUrl(key)
		return ApiUtils.get(url)
	}
}

export default ConfigStoreServiceApis
